import { gql } from '@apollo/client';

export const UploadSoaDocumentMutation = gql`
    mutation UploadSoaDocument(
        $type: StudentOnlineApplicationDocumentType!
        $variant: SoaDocumentFileVariant!
        $fileId: ID
        $documentRef: Boolean
    ) {
        uploadSoaDocument(
            type: $type
            variant: $variant
            fileId: $fileId
            documentRef: $documentRef
        ) {
            type
            status
            files {
                variant
                uploadTitle
                documentRef
                file {
                    id
                    name
                }
            }
        }
    }
`;
